import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { fetchJson } from "../../lib/Fetching";
import Button from "../Button";
import { addBranchRestrictions, removeBranchRestrictions } from "../../lib/ProductActions";

const TinyLink = styled.span`
  color: #5d9cec;
  font-size: 8pt;
  cursor: pointer;
`;

export default class ProductBranchesReport extends React.Component {
  state = {
    selectedProductIds: [],
    selectedCompanyBranchIds: [],
    company_branches: null
  };

  componentDidMount() {
    this.loadCompanyBranches();
  }

  loadCompanyBranches = () => {
    const { company_id } = this.props;
    fetchJson("/crm_api/company_branches", {
      company_id
    }).then(company_branches => {
      this.setState({ company_branches });
    });
  };

  addBranchRestrictions = () => {
    const { reloadProducts } = this.props;
    const { selectedProductIds, selectedCompanyBranchIds } = this.state;
    addBranchRestrictions(selectedProductIds, selectedCompanyBranchIds, reloadProducts);
  };

  removeBranchRestrictions = () => {
    const { reloadProducts } = this.props;
    const { selectedProductIds, selectedCompanyBranchIds } = this.state;
    removeBranchRestrictions(selectedProductIds, selectedCompanyBranchIds, reloadProducts);
  };

  selectProduct = product => {
    const { selectedProductIds } = this.state;
    this.setState({
      selectedProductIds: selectedProductIds.includes(product.id)
        ? selectedProductIds.filter(id => id !== product.id)
        : selectedProductIds.concat(product.id)
    });
  };

  selectCompanyBranch = companyBranch => {
    const { selectedCompanyBranchIds } = this.state;
    this.setState({
      selectedCompanyBranchIds: selectedCompanyBranchIds.includes(companyBranch.id)
        ? selectedCompanyBranchIds.filter(id => id !== companyBranch.id)
        : selectedCompanyBranchIds.concat(companyBranch.id)
    });
  };

  selectAllProducts = () =>
    this.setState({ selectedProductIds: this.props.products.map(p => p.id) });
  unSelectAllProducts = () => this.setState({ selectedProductIds: [] });

  render() {
    const { products } = this.props;
    const { selectedProductIds, selectedCompanyBranchIds, company_branches } = this.state;
    if (!company_branches) return null;
    return (
      <Fragment>
        <div className="btn-toolbar" style={{ marginBottom: 10 }}>
          <div className="btn-group">
            <Button
              onClick={this.removeBranchRestrictions}
              title="Remove Products From Selected Branches"
              disabled={selectedProductIds.length == 0 || selectedCompanyBranchIds.length == 0}
              deleting
              tiny
            />
          </div>
          <div className="btn-group">
            <Button
              onClick={this.addBranchRestrictions}
              title="Add Products To Selected Branches"
              disabled={selectedProductIds.length == 0 || selectedCompanyBranchIds.length == 0}
              primary
              tiny
            />
          </div>
        </div>
        <p>
          <TinyLink onClick={this.selectAllProducts}>Select All</TinyLink>{" "}
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <TinyLink onClick={this.unSelectAllProducts}>Un-Select All</TinyLink>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          {products.length} Products &nbsp;&nbsp;|&nbsp;&nbsp;
          {selectedProductIds.length} Selected Products
        </p>
        <div className="panel panel-default">
          <table className="table table-bordered table-condensed table-dense">
            <thead>
              <tr>
                <th style={{ width: 30 }}>&nbsp;</th>
                <th>{I18n.t('product')}</th>
                {company_branches.map(cb => (
                  <th className="text-center" key={cb.id}>
                    <label>
                      <input
                        type="checkbox"
                        checked={selectedCompanyBranchIds.includes(cb.id)}
                        onChange={() => this.selectCompanyBranch(cb)}
                      />
                      &nbsp;
                      {cb.name}
                    </label>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {products.map(p => (
                <tr key={p.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedProductIds.includes(p.id)}
                      onChange={() => this.selectProduct(p)}
                    />
                  </td>
                  <td>
                    <a href={"/products/products/" + p.id + "/show"}>{p.name}</a>
                  </td>
                  {company_branches.map(cb => (
                    <td className="text-center" key={cb.id}>
                      {p.company_branch_ids.includes(cb.id) && <i className="fa fa-check" />}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}

ProductBranchesReport.propTypes = {
  company_id: PropTypes.number,
  products: PropTypes.array,
  reloadProducts: PropTypes.func
};
